import {createReducer} from "../../../_common/common";
import {SET_HOMOLOGATION_DOWNLOADED, SET_HOMOLOGATION_STATUS} from "../actions/constants";


const initialState = {
    status: null
}

export const homologationStatus = createReducer(initialState, {
   [SET_HOMOLOGATION_STATUS]: (state, payload) => {
       state.status = payload;
       return state;
   }
});
